import { Injectable } from '@angular/core';
import { SocketioService } from './socketio.service';
import { KeyconfigInitService } from './init/keyconfig-init.service';
import { NumericFilterPipe } from './numeric-filter.pipe';
import { ServiceStock } from './service-stock.service';
import { gotxModalComponent } from './gotxModal/gotxModal.component';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  CONSTANTS;  
  ErrorCode;
  filltypeNameMap = new Map();
  notificationList = [];
  notifyCount = 0;

  constructor(private services: ServiceStock, private socketio: SocketioService, private configInitService: KeyconfigInitService,
    private numFilter: NumericFilterPipe) {
    this.configInitService.loadConstants().subscribe(data => {
      this.CONSTANTS = data;
    });

    // this.configInitService.loadAppResource().subscribe(data => {
    //   this.ErrorCode = data;
    // });

    this.filltypeNameMap.set("ctg_equity_0", "(GFD)");
    this.filltypeNameMap.set("ctg_equity_1", "(GTC)");
    this.filltypeNameMap.set("ctg_equity_3", "(IOC)");
    this.filltypeNameMap.set("ctg_equity_4", "(FOK)");
    this.filltypeNameMap.set("ctg_equity_6", "(GTD)");
    this.filltypeNameMap.set("ctg_equity_7", "(ATC)");
    this.filltypeNameMap.set("ctg_equity_8", "(ATO)");
    this.filltypeNameMap.set("ctg_equity_a", "(PFRK)");
    this.filltypeNameMap.set("ctg_equity_b", "(PFRC)");
    this.filltypeNameMap.set("ctg_equity_c", "(MFL)");

    this.filltypeNameMap.set("ctg_comderv_0", "(GFD)");
    this.filltypeNameMap.set("ctg_comderv_1", "(GTC)");
    this.filltypeNameMap.set("ctg_comderv_3", "(IOC)");
    this.filltypeNameMap.set("ctg_comderv_4", "(FOK)");
    this.filltypeNameMap.set("ctg_comderv_6", "(GTD)");
    this.filltypeNameMap.set("ctg_comderv_7", "(ATC)");
    this.filltypeNameMap.set("ctg_comderv_8", "(ATO)");
    this.filltypeNameMap.set("ctg_comderv_a", "(PFRK)");
    this.filltypeNameMap.set("ctg_comderv_b", "(PFRC)");
    this.filltypeNameMap.set("ctg_comderv_c", "(MFL)");

    this.filltypeNameMap.set("ctg_futopt_0", "(GFD)");
    this.filltypeNameMap.set("ctg_futopt_1", "(GTC)");
    this.filltypeNameMap.set("ctg_futopt_3", "(IOC)");
    this.filltypeNameMap.set("ctg_futopt_4", "(FOK)");
    this.filltypeNameMap.set("ctg_futopt_6", "(GTD)");
    this.filltypeNameMap.set("ctg_futopt_7", "(ATC)");
    this.filltypeNameMap.set("ctg_futopt_8", "(ATO)");
    this.filltypeNameMap.set("ctg_futopt_a", "(PFRK)");
    this.filltypeNameMap.set("ctg_futopt_b", "(PFRC)");
    this.filltypeNameMap.set("ctg_futopt_c", "(MFL)");
  }

  notificationSubs(notificationID: string) {
    let notifID = notificationID.split('.')
    let msg = "CTL.SUBSCRIBE#" + notifID[1] + "~" + notificationID;
    this.socketio.emit("SIOREQ", msg);
  }

  getNotifications(notificationID: string) {
    let notifID = notificationID.split('.')
    this.socketio.listen(notifID[1]).subscribe((message: any) => {
      this.handleNotification(message);
    });
  }

  handleNotification(message: any) {
    //#EFX0001 Begin
    //Socket Disconnected in middle
    // if (message == 'socketDisconnected') {
    //   $rootScope.$broadcast('disconnected');
    // }
    //#EFX0001 End
    //console.log("message",message);
    var notifiStr = message.split(this.CONSTANTS.MSG_SEPARATOR); // #
   //console.log("notifiStr",notifiStr);
    var msgHeader = notifiStr[0];

    if (msgHeader.indexOf(this.CONSTANTS.UNIQUE_MSG_TYPE) != -1) {
      // i = 14 because rest are in headers and only from 14 message body starts
      for (var i = 1; i < notifiStr.length; i++) {
        var msgBody = notifiStr[i];
        //console.log("msgBody",msgBody);
        if (msgBody.length > 1) {
          var notfMsg = msgBody.split(this.CONSTANTS.MSG_BODY_SEPARATOR); // ~
          //console.log("notfMsg",notfMsg);
          var appHeader = notfMsg[0];
          console.log("appHeader",appHeader);
          var resObj = {};
          if (appHeader == this.CONSTANTS.TRDEXCNO) {
            resObj = this.init_tradeExecObj(notfMsg);
            var notfMessage = this.getMessage(appHeader, resObj);
            this.notificationMessage(notfMessage);

          } else if (appHeader == this.CONSTANTS.EQORADNO) {
           // console.log("EQORADNO inside");
            resObj = this.init_orderAddAcceptObj(notfMsg);
           // console.log("EQORADNO inside",resObj);
            var notfMessage = this.getMessage(appHeader, resObj);
            this.notificationMessage(notfMessage);

          } else if (appHeader == this.CONSTANTS.EQORARNO) {
            resObj = this.init_orderAddRejectObj(notfMsg);
            var notfMessage = this.getMessage(appHeader, resObj);
            this.notificationMessage(notfMessage);

          } else if (appHeader == this.CONSTANTS.EQORMONO) {
            resObj = this.init_orderModAcceptObj(notfMsg);
            var notfMessage = this.getMessage(appHeader, resObj);
            this.notificationMessage(notfMessage);

          } else if (appHeader == this.CONSTANTS.EQORRJNO) {
            resObj = this.init_orderModRejectObj(notfMsg);
            var notfMessage = this.getMessage(appHeader, resObj);
            this.notificationMessage(notfMessage);

          } else if (appHeader == this.CONSTANTS.EQORCANO) {
            resObj = this.init_orderCancelAcceptObj(notfMsg);
            var notfMessage = this.getMessage(appHeader, resObj);
            this.notificationMessage(notfMessage);

          } else if (appHeader == this.CONSTANTS.EQORRJNO) {
            resObj = this.init_orderCancelRejectObj(notfMsg);
            var notfMessage = this.getMessage(appHeader, resObj);
            this.notificationMessage(notfMessage);

          } else if (appHeader == this.CONSTANTS.OROWCHNO) {
            resObj = this.init_orderOwnershipChangeObj(notfMsg);
            var notfMessage = this.getMessage(appHeader, resObj);
            this.notificationMessage(notfMessage);
          } 
          //added by shanmugapriya for spread
          else if (appHeader == this.CONSTANTS.SPORADNO) { //add
            console.log("SPORADNO inside");
            resObj = this.init_orderAddAcceptObj(notfMsg);
            console.log("SPORADNO inside",resObj);
            var notfMessage = this.getMessage(appHeader, resObj);
            this.notificationMessage(notfMessage);
          } else if (appHeader == this.CONSTANTS.SPORCAAO) { //cancel
            resObj = this.init_orderCancelAcceptObj(notfMsg);
            var notfMessage = this.getMessage(appHeader, resObj);
            this.notificationMessage(notfMessage);
          }
          else if (appHeader == this.CONSTANTS.SPORADRO) { //add reject
            resObj = this.init_orderAddRejectObj(notfMsg);
            var notfMessage = this.getMessage(appHeader, resObj);
            this.notificationMessage(notfMessage);
          }
        }
      }
    }
  }

  init_tradeExecObj(notfMsg) {
    var resObj = {};
    var startIndex = 3;
    resObj["orderID"] = notfMsg[startIndex++];
    resObj["secOrderID"] = notfMsg[startIndex++];
    resObj["clOrdID"] = notfMsg[startIndex++];
    resObj["tradeID"] = notfMsg[startIndex++];
    resObj["execID"] = notfMsg[startIndex++];
    resObj["clientID"] = notfMsg[startIndex++];
    resObj["symbol"] = notfMsg[startIndex++];
    resObj["product"] = notfMsg[startIndex++];
    resObj["cifCode"] = notfMsg[startIndex++];
    resObj["exDestination"] = notfMsg[startIndex++];
    resObj["cashMargin"] = notfMsg[startIndex++];
    resObj["price"] = notfMsg[startIndex++];
    resObj["avgPx"] = notfMsg[startIndex++];
    resObj["orderQty"] = notfMsg[startIndex++];
    resObj["leavesQty"] = notfMsg[startIndex++];
    resObj["cumQty"] = notfMsg[startIndex++];
    resObj["orderType"] = notfMsg[startIndex++];
    resObj["side"] = notfMsg[startIndex++];
    resObj["orderCapacity"] = notfMsg[startIndex++];
    resObj["timeInForce"] = notfMsg[startIndex++];
    resObj["orderStatus"] = notfMsg[startIndex++];
    resObj["settlementNum"] = notfMsg[startIndex++];
    resObj["settlorID"] = notfMsg[startIndex++];
    resObj["contraBrokerID"] = notfMsg[startIndex++];
    resObj["brokerClientType"] = notfMsg[startIndex++];
    resObj["exchangeLMDate"] = this.services.dataStore.dateConversion(notfMsg[startIndex++]);
    resObj["exchangeLMTime"] = this.services.timePipe.transform(notfMsg[startIndex++]);
    resObj["lastTransactDate"] = this.services.dataStore.dateConversion(notfMsg[startIndex++]);
    resObj["lastTransactTime"] = this.services.timePipe.transform(notfMsg[startIndex++]);
    resObj["accuredInterest"] = notfMsg[startIndex++];
    resObj["yield"] = notfMsg[startIndex++];
    resObj["executedYield"] = notfMsg[startIndex++];
    resObj["convertedPrice"] = notfMsg[startIndex++];
    resObj["convertedValue"] = notfMsg[startIndex++];
    return resObj;
  }

  init_orderAddAcceptObj(notfMsg) {
    var resObj = {};
    var startIndex = 3;

    resObj["orderID"] = "";
    resObj["secOrderID"] = "";
    resObj["clOrdID"] = "";
    resObj["clientID"] = "";
    resObj["noOfOrderLegs"] = "";
    resObj["orderLegNum"] = "";
    resObj["symbol"] = "";
    resObj["product"] = "";
    resObj["cifCode"] = "";
    resObj["exDestination"] = "";
    resObj["cashMargin"] = "";
    resObj["orderType"] = "";
    resObj["side"] = "";
    resObj["price"] = "";
    resObj["stopPx"] = "";
    resObj["mktProtectionPercentage"] = "";
    resObj["orderQty"] = "";
    resObj["leavesQty"] = "";
    resObj["cumQty"] = "";
    resObj["maxFloor"] = "";
    resObj["minQty"] = "";
    resObj["execInst"] = "";
    resObj["orderCapacity"] = "";
    resObj["timeInForce"] = "";
    resObj["expiryDate"] = "";
    resObj["exchangeSubmitDate"] = "";
    resObj["rejectCode"] = "";
    resObj["orderStatus"] = "";
    resObj["orderSubStatus"] = "";
    resObj["settlorID"] = "";
    resObj["brokerClientType"] = "";
    resObj["exchangeLMDate"] = "";
    resObj["exchangeLMTime"] = "";
    resObj["lastTransactDate"] = "";
    resObj["lastTransactTime"] = "";
    resObj["commission"] = "";
    resObj["reason"] = "";
    resObj["bookType"] = "";
    resObj["orderID"] = notfMsg[startIndex++];  
    resObj["secOrderID"] = notfMsg[startIndex++]; 
    resObj["clOrdID"] = notfMsg[startIndex++];   
    resObj["clientID"] = notfMsg[startIndex++];
    resObj["noOfOrderLegs"] = notfMsg[startIndex++];  
    resObj["orderLegNum"] = notfMsg[startIndex++]; 
    resObj["symbol"] = notfMsg[startIndex++];
    resObj["product"] = notfMsg[startIndex++];
    resObj["cifCode"] = notfMsg[startIndex++];
    resObj["exDestination"] = notfMsg[startIndex++];
    resObj["cashMargin"] = notfMsg[startIndex++];
    resObj["orderType"] = notfMsg[startIndex++];
    resObj["side"] = notfMsg[startIndex++];
    resObj["price"] = notfMsg[startIndex++];
    resObj["stopPx"] = notfMsg[startIndex++];
    resObj["mktProtectionPercentage"] = notfMsg[startIndex++];
    resObj["orderQty"] = notfMsg[startIndex++];
    resObj["leavesQty"] = notfMsg[startIndex++];
    resObj["cumQty"] = notfMsg[startIndex++];
    resObj["maxFloor"] = notfMsg[startIndex++];
    resObj["minQty"] = notfMsg[startIndex++];
    resObj["execInst"] = notfMsg[startIndex++];
    resObj["orderCapacity"] = notfMsg[startIndex++];
    resObj["timeInForce"] = notfMsg[startIndex++];
    resObj["expiryDate"] = notfMsg[startIndex++];
    resObj["exchangeSubmitDate"] = notfMsg[startIndex++];
    resObj["rejectCode"] = notfMsg[startIndex++];
    resObj["orderStatus"] = notfMsg[startIndex++];
    resObj["orderSubStatus"] = notfMsg[startIndex++];
    resObj["settlorID"] = notfMsg[startIndex++];
    resObj["brokerClientType"] = notfMsg[startIndex++];
    resObj["exchangeLMDate"] = this.services.dataStore.dateConversion(notfMsg[startIndex++]);
    resObj["exchangeLMTime"] = this.services.timePipe.transform(notfMsg[startIndex++]);
    startIndex++; // Added to fix the index for date    
    resObj["lastTransactDate"] = this.services.dataStore.dateConversion(notfMsg[startIndex++]);
    resObj["lastTransactTime"] = this.services.timePipe.transform(notfMsg[startIndex++]);
    resObj["commission"] = notfMsg[startIndex++];
    if (typeof notfMsg[startIndex + 1] != "undefined") {
      resObj["reason"] = notfMsg[startIndex++];
    } else {
      resObj["reason"] = "";
    }
    resObj["bookType"] = notfMsg[startIndex++];
    return resObj;
  }

  init_orderAddRejectObj(notfMsg) {
    var resObj = {};
    var startIndex = 3;
//console.log("orderadd rej resobj",notfMsg);
    resObj["orderID"] = "";
    resObj["secOrderID"] = "";
    resObj["clOrdID"] = "";
    resObj["clientID"] = "";
    resObj["noOfOrderLegs"] = "";
    resObj["orderLegNum"] = "";
    resObj["symbol"] = "";
    resObj["product"] = "";
    resObj["cifCode"] = "";
    resObj["exDestination"] = "";
    resObj["cashMargin"] = "";
    resObj["orderType"] = "";
    resObj["side"] = "";
    resObj["price"] = "";
    resObj["stopPx"] = "";
    resObj["mktProtectionPercentage"] = "";
    resObj["orderQty"] = "";
    resObj["leavesQty"] = "";
    resObj["cumQty"] = "";
    resObj["maxFloor"] = "";
    resObj["minQty"] = "";
    resObj["execInst"] = "";
    resObj["orderCapacity"] = "";
    resObj["timeInForce"] = "";
    resObj["expiryDate"] = "";
    resObj["exchangeSubmitDate"] = "";
    resObj["rejectCode"] = "";
    resObj["orderStatus"] = "";
    resObj["orderSubStatus"] = "";
    resObj["shortQty"] = "";
    resObj["shortLimit"] = "";
    resObj["settlorID"] = "";
    resObj["exchangeLMDate"] = "";
    resObj["exchangeLMTime"] = "";
    resObj["lastTransactDate"] = "";
    resObj["lastTransactTime"] = "";
    resObj["exchangeRemarksLength"] = "";
    resObj["exchangeRemarks"] = "";
    resObj["rejectSource"] = "";
    resObj["commission"] = "";
    resObj["reason"] = "";
    resObj["bookType"] = "";

    resObj["orderID"] = notfMsg[startIndex++];
   // console.log("order id",resObj["orderID"]);
    resObj["secOrderID"] = notfMsg[startIndex++];
    resObj["clOrdID"] = notfMsg[startIndex++];
    resObj["clientID"] = notfMsg[startIndex++];
    resObj["noOfOrderLegs"] = notfMsg[startIndex++];
    resObj["orderLegNum"] = notfMsg[startIndex++];
    resObj["symbol"] = notfMsg[startIndex++];
    resObj["product"] = notfMsg[startIndex++];
    resObj["cifCode"] = notfMsg[startIndex++];
    resObj["exDestination"] = notfMsg[startIndex++];
    resObj["cashMargin"] = notfMsg[startIndex++];
    resObj["orderType"] = notfMsg[startIndex++];
    resObj["side"] = notfMsg[startIndex++];
    resObj["price"] = notfMsg[startIndex++];
    resObj["stopPx"] = notfMsg[startIndex++];
    resObj["mktProtectionPercentage"] = notfMsg[startIndex++];
    resObj["orderQty"] = notfMsg[startIndex++];
    resObj["leavesQty"] = notfMsg[startIndex++];
    resObj["cumQty"] = notfMsg[startIndex++];
    resObj["maxFloor"] = notfMsg[startIndex++];
    resObj["minQty"] = notfMsg[startIndex++];
    resObj["execInst"] = notfMsg[startIndex++];
    resObj["orderCapacity"] = notfMsg[startIndex++];
    resObj["timeInForce"] = notfMsg[startIndex++];
    resObj["expiryDate"] = notfMsg[startIndex++];
    resObj["exchangeSubmitDate"] = notfMsg[startIndex++];
    resObj["rejectCode"] = notfMsg[startIndex++];
    resObj["orderStatus"] = notfMsg[startIndex++];
    resObj["orderSubStatus"] = notfMsg[startIndex++];
    resObj["shortQty"] = notfMsg[startIndex++];
    resObj["shortLimit"] = notfMsg[startIndex++];
    resObj["settlorID"] = notfMsg[startIndex++];
    resObj["exchangeLMDate"] = this.services.dataStore.dateConversion(notfMsg[startIndex++]);
    resObj["exchangeLMTime"] = this.services.timePipe.transform(notfMsg[startIndex++]);
    startIndex++; // Added to fix the index for date
    resObj["lastTransactDate"] = this.services.dataStore.dateConversion(notfMsg[startIndex++]);
    resObj["lastTransactTime"] = this.services.timePipe.transform(notfMsg[startIndex++]);
    resObj["exchangeRemarksLength"] = notfMsg[startIndex++];
    resObj["exchangeRemarks"] = notfMsg[startIndex++];
    resObj["rejectSource"] = notfMsg[startIndex++];
    resObj["commission"] = notfMsg[startIndex++];
    //if (typeof notfMsg[startIndex + 1] != "undefined") {
    resObj["reason"] = notfMsg[startIndex++];
    /*} else {
      resObj["reason"] = "";
    }*/ //commented by shanmuga priya

    resObj["bookType"] = notfMsg[startIndex++];
    return resObj;
  }

  init_orderModAcceptObj(notfMsg) {
    var resObj = {};
    var startIndex = 3;

    resObj["orderID"] = "";
    resObj["secOrderID"] = "";
    resObj["clOrdID"] = "";
    resObj["clientID"] = "";
    resObj["noOfOrderLegs"] = "";
    resObj["orderLegNum"] = "";
    resObj["symbol"] = "";
    resObj["product"] = "";
    resObj["cifCode"] = "";
    resObj["exDestination"] = "";
    resObj["cashMargin"] = "";
    resObj["orderType"] = "";
    resObj["side"] = "";
    resObj["price"] = "";
    resObj["stopPx"] = "";
    resObj["orderQty"] = "";
    resObj["leavesQty"] = "";
    resObj["cumQty"] = "";
    resObj["maxFloor"] = "";
    resObj["minQty"] = "";
    resObj["execInst"] = "";
    resObj["orderCapacity"] = "";
    resObj["timeInForce"] = "";
    resObj["expiryDate"] = "";
    resObj["exchangeSubmitDate"] = "";
    resObj["orderStatus"] = "";
    resObj["orderSubStatus"] = "";
    resObj["exchangeLMDate"] = "";
    resObj["exchangeLMTime"] = "";
    resObj["lastTransactDate"] = "";
    resObj["lastTransactTime"] = "";
    resObj["commission"] = "";
    resObj["reason"] = "";
    resObj["bookType"] = "";

    resObj["orderID"] = notfMsg[startIndex++];
    resObj["secOrderID"] = notfMsg[startIndex++];
    resObj["clOrdID"] = notfMsg[startIndex++];
    resObj["clientID"] = notfMsg[startIndex++];
    resObj["noOfOrderLegs"] = notfMsg[startIndex++];
    resObj["orderLegNum"] = notfMsg[startIndex++];
    resObj["symbol"] = notfMsg[startIndex++];
    resObj["product"] = notfMsg[startIndex++];
    resObj["cifCode"] = notfMsg[startIndex++];
    resObj["exDestination"] = notfMsg[startIndex++];
    resObj["cashMargin"] = notfMsg[startIndex++];
    resObj["orderType"] = notfMsg[startIndex++];
    resObj["side"] = notfMsg[startIndex++];
    resObj["price"] = notfMsg[startIndex++];
    resObj["stopPx"] = notfMsg[startIndex++];
    resObj["orderQty"] = notfMsg[startIndex++];
    resObj["leavesQty"] = notfMsg[startIndex++];
    resObj["cumQty"] = notfMsg[startIndex++];
    resObj["maxFloor"] = notfMsg[startIndex++];
    resObj["minQty"] = notfMsg[startIndex++];
    resObj["execInst"] = notfMsg[startIndex++];
    resObj["orderCapacity"] = notfMsg[startIndex++];
    resObj["timeInForce"] = notfMsg[startIndex++];
    resObj["expiryDate"] = notfMsg[startIndex++];
    resObj["exchangeSubmitDate"] = notfMsg[startIndex++];
    resObj["orderStatus"] = notfMsg[startIndex++];
    resObj["orderSubStatus"] = notfMsg[startIndex++];
    startIndex++; // Added to fix the index for date
    resObj["exchangeLMDate"] = this.services.dataStore.dateConversion(notfMsg[startIndex++]);
    resObj["exchangeLMTime"] = this.services.timePipe.transform(notfMsg[startIndex++]);
    resObj["lastTransactDate"] = this.services.dataStore.dateConversion(notfMsg[startIndex++]);
    resObj["lastTransactTime"] = this.services.timePipe.transform(notfMsg[startIndex++]);
    resObj["commission"] = notfMsg[startIndex++];
    if (typeof notfMsg[startIndex + 1] != "undefined") {
      resObj["reason"] = notfMsg[startIndex++];
    } else {
      resObj["reason"] = "";
    }
    resObj["bookType"] = notfMsg[startIndex++];
    return resObj;
  }

  init_orderModRejectObj(notfMsg) {
    var resObj = {};
    var startIndex = 3;
    resObj["orderID"] = "";
    resObj["secOrderID"] = "";
    resObj["clOrdID"] = "";
    resObj["clientID"] = "";
    resObj["noOfOrderLegs"] = "";
    resObj["orderLegNum"] = "";
    resObj["product"] = "";
    resObj["exDestination"] = "";
    resObj["rejectedBy"] = "";
    resObj["rejectCode"] = "";
    resObj["cxlRejResponseTo"] = "";
    resObj["orderStatus"] = "";
    resObj["shortQty"] = "";
    resObj["shortLimit"] = "";
    resObj["exchangeLMDate"] = "";
    resObj["exchangeLMTime"] = "";
    resObj["lastTransactDate"] = "";
    resObj["lastTransactTime"] = "";
    resObj["exchangeRemarksLength"] = "";
    resObj["exchangeRemarks"] = "";
    resObj["m_OrdExpDate"] = "";
    resObj["commission"] = "";
    resObj["reason"] = "";
    resObj["bookType"] = "";

    resObj["orderID"] = notfMsg[startIndex++]; //22500096G003170
    resObj["secOrderID"] = notfMsg[startIndex++]; //O0CG73QBGK7t
    resObj["clOrdID"] = notfMsg[startIndex++]; //Test
    resObj["clientID"] = notfMsg[startIndex++]; //22500096
    resObj["noOfOrderLegs"] = notfMsg[startIndex++]; //0
    resObj["orderLegNum"] = notfMsg[startIndex++]; //0
    resObj["product"] = notfMsg[startIndex++]; //5
    resObj["exDestination"] = notfMsg[startIndex++]; //CTG
    resObj["rejectedBy"] = notfMsg[startIndex++]; //E
    resObj["rejectCode"] = notfMsg[startIndex++]; // 14002
    resObj["cxlRejResponseTo"] = notfMsg[startIndex++]; // 1
    resObj["orderStatus"] = notfMsg[startIndex++]; // 0
    resObj["shortQty"] = notfMsg[startIndex++]; // 0
    resObj["shortLimit"] = notfMsg[startIndex++]; // 0
    startIndex++;    // Added to fix the index for date
    resObj["exchangeLMDate"] = this.services.dataStore.dateConversion(notfMsg[startIndex++]) //20221109
    resObj["exchangeLMTime"] = this.services.timePipe.transform(notfMsg[startIndex++]); //161007692
    resObj["lastTransactDate"] = this.services.dataStore.dateConversion(notfMsg[startIndex++]); //20221109
    resObj["lastTransactTime"] = this.services.timePipe.transform(notfMsg[startIndex++]); //161007705462
    resObj["exchangeRemarksLength"] = notfMsg[startIndex++]; //53
    resObj["exchangeRemarks"] = notfMsg[startIndex++]; //Order not found (too late to cancel or unknown order)
    resObj["m_OrdExpDate"] = notfMsg[startIndex++];
    resObj["commission"] = notfMsg[startIndex++];
    if (typeof notfMsg[startIndex + 1] != "undefined") {
      resObj["reason"] = notfMsg[startIndex++];
    } else {
      resObj["reason"] = "";
    }
    resObj["bookType"] = notfMsg[startIndex++];
    return resObj;
  }

  init_orderCancelAcceptObj(notfMsg) {
    var resObj = {};
    var startIndex = 3;

    resObj["orderID"] = "";
    resObj["secOrderID"] = "";
    resObj["clOrdID"] = "";
    resObj["clientID"] = "";
    resObj["noOfOrderLegs"] = "";
    resObj["orderLegNum"] = "";
    resObj["symbol"] = "";
    resObj["product"] = "";
    resObj["cifCode"] = "";
    resObj["exDestination"] = "";
    resObj["cashMargin"] = "";
    resObj["orderType"] = "";
    resObj["side"] = "";
    resObj["price"] = "";
    resObj["stopPx"] = "";
    resObj["orderQty"] = "";
    resObj["leavesQty"] = "";
    resObj["cumQty"] = "";
    resObj["maxFloor"] = "";
    resObj["minQty"] = "";
    resObj["cancelledQty"] = "";
    resObj["execInst"] = "";
    resObj["orderCapacity"] = "";
    resObj["timeInForce"] = "";
    resObj["expiryDate"] = "";
    resObj["orderStatus"] = "";
    resObj["orderSubStatus"] = "";
    resObj["exchangeLMDate"] = "";
    resObj["exchangeLMTime"] = "";
    resObj["lastTransactDate"] = "";
    resObj["lastTransactTime"] = "";
    resObj["bookType"] = "";

    resObj["orderID"] = notfMsg[startIndex++];
    resObj["secOrderID"] = notfMsg[startIndex++];
    resObj["clOrdID"] = notfMsg[startIndex++];
    resObj["clientID"] = notfMsg[startIndex++];
    resObj["noOfOrderLegs"] = notfMsg[startIndex++];
    resObj["orderLegNum"] = notfMsg[startIndex++];
    resObj["symbol"] = notfMsg[startIndex++];
    resObj["product"] = notfMsg[startIndex++];
    resObj["cifCode"] = notfMsg[startIndex++];
    resObj["exDestination"] = notfMsg[startIndex++];
    resObj["cashMargin"] = notfMsg[startIndex++];
    resObj["orderType"] = notfMsg[startIndex++];
    resObj["side"] = notfMsg[startIndex++];
    resObj["price"] = notfMsg[startIndex++];
    resObj["stopPx"] = notfMsg[startIndex++];
    resObj["orderQty"] = notfMsg[startIndex++];
    resObj["leavesQty"] = notfMsg[startIndex++];
    resObj["cumQty"] = notfMsg[startIndex++];
    resObj["maxFloor"] = notfMsg[startIndex++];
    resObj["minQty"] = notfMsg[startIndex++];
    resObj["cancelledQty"] = notfMsg[startIndex++];
    resObj["execInst"] = notfMsg[startIndex++];
    resObj["orderCapacity"] = notfMsg[startIndex++];
    resObj["timeInForce"] = notfMsg[startIndex++];
    resObj["expiryDate"] = notfMsg[startIndex++];
    resObj["orderStatus"] = notfMsg[startIndex++];
    resObj["orderSubStatus"] = notfMsg[startIndex++];
    startIndex++;    // Added to fix the index for date
    resObj["exchangeLMDate"] = this.services.dataStore.dateConversion(notfMsg[startIndex++])
    resObj["exchangeLMTime"] = this.services.timePipe.transform(notfMsg[startIndex++]);
    resObj["lastTransactDate"] = this.services.dataStore.dateConversion(notfMsg[startIndex++]);
    resObj["lastTransactTime"] = this.services.timePipe.transform(notfMsg[startIndex++]);
    resObj["bookType"] = notfMsg[startIndex++];
    return resObj;
  }

  init_orderCancelRejectObj(notfMsg) {
    var resObj = {};
    var startIndex = 3;

    resObj["orderID"] = "";
    resObj["secOrderID"] = "";
    resObj["clOrdID"] = "";
    resObj["noOfOrderLegs"] = "";
    resObj["orderLegNum"] = "";
    resObj["symbol"] = "";
    resObj["product"] = "";
    resObj["cifCode"] = "";
    resObj["exDestination"] = "";
    resObj["cashMargin"] = "";
    resObj["orderType"] = "";
    resObj["side"] = "";
    resObj["price"] = "";
    resObj["stopPx"] = "";
    resObj["orderQty"] = "";
    resObj["leavesQty"] = "";
    resObj["cumQty"] = "";
    resObj["maxFloor"] = "";
    resObj["minQty"] = "";
    resObj["cancelledQty"] = "";
    resObj["execInst"] = "";
    resObj["orderCapacity"] = "";
    resObj["timeInForce"] = "";
    resObj["expiryDate"] = "";
    resObj["orderStatus"] = "";
    resObj["orderSubStatus"] = "";
    resObj["exchangeLMDate"] = "";
    resObj["exchangeLMTime"] = "";
    resObj["lastTransactDate"] = "";
    resObj["lastTransactTime"] = "";
    resObj["bookType"] = "";

    resObj["orderID"] = notfMsg[startIndex++];
    resObj["secOrderID"] = notfMsg[startIndex++];
    resObj["clOrdID"] = notfMsg[startIndex++];
    resObj["clientID"] = notfMsg[startIndex++];
    resObj["noOfOrderLegs"] = notfMsg[startIndex++];
    resObj["orderLegNum"] = notfMsg[startIndex++];
    resObj["symbol"] = notfMsg[startIndex++];
    resObj["product"] = notfMsg[startIndex++];
    resObj["cifCode"] = notfMsg[startIndex++];
    resObj["exDestination"] = notfMsg[startIndex++];
    resObj["cashMargin"] = notfMsg[startIndex++];
    resObj["orderType"] = notfMsg[startIndex++];
    resObj["side"] = notfMsg[startIndex++];
    resObj["price"] = notfMsg[startIndex++];
    resObj["stopPx"] = notfMsg[startIndex++];
    resObj["orderQty"] = notfMsg[startIndex++];
    resObj["leavesQty"] = notfMsg[startIndex++];
    resObj["cumQty"] = notfMsg[startIndex++];
    resObj["maxFloor"] = notfMsg[startIndex++];
    resObj["minQty"] = notfMsg[startIndex++];
    resObj["cancelledQty"] = notfMsg[startIndex++];
    resObj["execInst"] = notfMsg[startIndex++];
    resObj["orderCapacity"] = notfMsg[startIndex++];
    resObj["timeInForce"] = notfMsg[startIndex++];
    resObj["expiryDate"] = notfMsg[startIndex++];
    resObj["orderStatus"] = notfMsg[startIndex++];
    resObj["orderSubStatus"] = notfMsg[startIndex++];
    resObj["exchangeLMDate"] = this.services.dataStore.dateConversion(notfMsg[startIndex++])
    resObj["exchangeLMTime"] = this.services.timePipe.transform(notfMsg[startIndex++]);
    resObj["lastTransactTime"] = this.services.timePipe.transform(notfMsg[startIndex++]);
    resObj["lastTransactDate"] = this.services.dataStore.dateConversion(notfMsg[startIndex++]);
    resObj["bookType"] = notfMsg[startIndex++];
    return resObj;
  }

  init_orderOwnershipChangeObj(notfMsg) {
    var resObj = {};
    var startIndex = 3;

    resObj["orderID"] = "";
    resObj["secOrderID"] = "";
    resObj["clOrdID"] = "";
    resObj["clientID"] = "";
    resObj["noOfOrderLegs"] = "";
    resObj["orderLegNum"] = "";
    resObj["symbol"] = "";
    resObj["product"] = "";
    resObj["cifCode"] = "";
    resObj["exDestination"] = "";
    resObj["cashMargin"] = "";
    resObj["orderType"] = "";
    resObj["side"] = "";
    resObj["price"] = "";
    resObj["stopPx"] = "";
    resObj["orderQty"] = "";
    resObj["leavesQty"] = "";
    resObj["cumQty"] = "";
    resObj["maxFloor"] = "";
    resObj["execInst"] = "";
    resObj["orderCapacity"] = "";
    resObj["timeInForce"] = "";
    resObj["expiryDate"] = "";
    resObj["orderStatus"] = "";
    resObj["orderSubStatus"] = "";
    resObj["brokerClientType"] = "";
    resObj["exchangeLMDate"] = "";
    resObj["exchangeLMTime"] = "";
    resObj["lastTransactDate"] = "";
    resObj["lastTransactTime"] = "";
    resObj["commission"] = "";
    resObj["reason"] = "";
    resObj["bookType"] = "";

    resObj["orderID"] = notfMsg[startIndex++];
    resObj["secOrderID"] = notfMsg[startIndex++];
    resObj["clOrdID"] = notfMsg[startIndex++];
    resObj["clientID"] = notfMsg[startIndex++];
    resObj["noOfOrderLegs"] = notfMsg[startIndex++];
    resObj["orderLegNum"] = notfMsg[startIndex++];
    resObj["symbol"] = notfMsg[startIndex++];
    resObj["product"] = notfMsg[startIndex++];
    resObj["cifCode"] = notfMsg[startIndex++];
    resObj["exDestination"] = notfMsg[startIndex++];
    resObj["cashMargin"] = notfMsg[startIndex++];
    resObj["orderType"] = notfMsg[startIndex++];
    resObj["side"] = notfMsg[startIndex++];
    resObj["price"] = notfMsg[startIndex++];
    resObj["stopPx"] = notfMsg[startIndex++];
    resObj["orderQty"] = notfMsg[startIndex++];
    resObj["leavesQty"] = notfMsg[startIndex++];
    resObj["cumQty"] = notfMsg[startIndex++];
    resObj["maxFloor"] = notfMsg[startIndex++];
    resObj["minQty"] = notfMsg[startIndex++];
    resObj["execInst"] = notfMsg[startIndex++];
    resObj["orderCapacity"] = notfMsg[startIndex++];
    resObj["timeInForce"] = notfMsg[startIndex++];
    resObj["expiryDate"] = notfMsg[startIndex++];
    resObj["orderStatus"] = notfMsg[startIndex++];
    resObj["orderSubStatus"] = notfMsg[startIndex++];
    resObj["brokerClientType"] = notfMsg[startIndex++];
    startIndex++;    // Added to fix the index for date
    resObj["exchangeLMDate"] = this.services.dataStore.dateConversion(notfMsg[startIndex++])
    resObj["exchangeLMTime"] = this.services.timePipe.transform(notfMsg[startIndex++]);
    resObj["lastTransactDate"] = this.services.dataStore.dateConversion(notfMsg[startIndex++]);
    resObj["lastTransactTime"] = this.services.timePipe.transform(notfMsg[startIndex++]);
    resObj["commission"] = notfMsg[startIndex++];
    if (typeof notfMsg[startIndex + 1] != "undefined") {
      resObj["reason"] = notfMsg[startIndex++];
    } else {
      resObj["reason"] = "";
    }
    resObj["bookType"] = notfMsg[startIndex++];
    return resObj;
  }

  //orderID --> secOrderID , tradeID --> execID
  getMessage(appHeader, resObj) {
  console.log("resObj in getmessage",resObj);
    var fullMessage = "";
    resObj["dispExch"] = this.services.dataStore.getDispExch(resObj["exDestination"]);
    if (resObj["orderQty"] > 0 && resObj["price"] == 0) {
      resObj["price"] = "MKT";
    } else {
      resObj["price"] = this.numFilter.formatTwoDecimal(resObj["price"] / 10000)
    }
    if (appHeader == "TRDEXCNO") {
      resObj["product"] = this.getProductType(resObj["product"]);
      if (this.services.getEnvironment().shortNotification) {
        fullMessage = resObj["lastTransactTime"] + "  Exchange: TRADE " + this.tradeOrderVerb(resObj["side"]) + " against " + this.symbolName(resObj["symbol"], resObj["exDestination"], resObj["product"]) + " " + resObj["orderQty"] + " OUT OF " + (parseInt(resObj["cumQty"]) + parseInt(resObj["leavesQty"])) + " at " + resObj["price"] + " for client " + resObj["clientID"];
      } else {
        fullMessage = resObj["lastTransactDate"] + " " + resObj["lastTransactTime"] + " Exchange Time: [" + resObj["exchangeLMTime"] + "] EQUITY TRADE: " + this.tradeOrderVerb(resObj["side"]) + " against ExchangeOrderNo: " + resObj["secOrderID"] + " " + this.symbolName(resObj["symbol"], resObj["exDestination"], resObj["product"]) + " / " + resObj["dispExch"] + " " + resObj["orderQty"] + " out of " + (parseInt(resObj["cumQty"]) + parseInt(resObj["leavesQty"])) + " at " + resObj["price"] + " for client " + resObj["clientID"] + ",ExchangeTradeNo: " + resObj["execID"] + ".";
      }
    } else if (appHeader == "EQORADNO") {

      resObj["product"] = this.getProductType(resObj["product"]);
      resObj["orderType"] = this.getOrderType(resObj["orderType"]);
      resObj["cashMargin"] = this.getCashMarginType(resObj["cashMargin"]);

      if (this.services.getEnvironment().shortNotification) {
        fullMessage = resObj["lastTransactTime"] + "  Exchange: Order Confirmed " + this.symbolName(resObj["symbol"], resObj["exDestination"], resObj["product"]) + " " + this.orderVerbType(resObj["side"]) + " " + resObj["orderQty"] + " @ " + resObj["price"] + " for Client " + resObj["clientID"];
      } else {
        fullMessage = resObj["lastTransactDate"] + " " + resObj["lastTransactTime"] + " Exchange Time: [" + resObj["exchangeLMTime"] + "] " + resObj["product"] + " " + resObj["orderType"] + " Order Confirmed - " + resObj["dispExch"] + " ExchangeOrderNo : " + resObj["secOrderID"] + " & IntellectOrderNo : " + resObj["orderID"] + " " + resObj["cashMargin"] + " " + this.symbolName(resObj["symbol"], resObj["exDestination"], resObj["product"]) + " " + this.orderVerbType(resObj["side"]) + " " + resObj["orderQty"] + " @ " + resObj["price"] + " " + this.fillTypeName(resObj["exDestination"], resObj["product"], resObj["timeInForce"]) + " for Client " + resObj["clientID"] + ".";
      }

    } else if (appHeader == "EQORARNO") {
      resObj["reason"] = resObj["exchangeRemarks"];
      console.log("resObj rejectCode",resObj["rejectCode"]);
      if (resObj["rejectCode"] == "5204") {
        resObj["reason"] = " System cannot accept order entry";
      } else if (resObj["rejectCode"] == "5205") {
        resObj["reason"] = " System cannot accept order modification"
      } else if (resObj["rejectCode"] == "5206") {
        resObj["reason"] = " System cannot accept order cancellation"
      } else if (resObj["rejectCode"] == "7001") {
        resObj["reason"] = " Insufficient funds to place order"
      } else if (resObj["rejectCode"] == "7002") {
        resObj["reason"] = " Stock is in trade for trade segment,IT not allowed "
      } else if (resObj["rejectCode"] == "7003") {
        resObj["reason"] = " Investor cannot trade on IT "
      } else if (resObj["rejectCode"] == "7004") {
        resObj["reason"] = " Stock not allowed for SS"
      } else if (resObj["rejectCode"] == "7005") {
        resObj["reason"] = " Investor not allowed for SS"
      } else if (resObj["rejectCode"] == "7006") {
        resObj["reason"] = " Not Allowed For the Participant "
      } else if (resObj["rejectCode"] == "7007") {
        resObj["reason"] = " Stock Group not allowed for SS "
      } else if (resObj["rejectCode"] == "7008") {
        resObj["reason"] = " Stock not available "
      } else if (resObj["rejectCode"] == "7009") {
        resObj["reason"] = " Requested Qty for Conv is zero "
      } else if (resObj["rejectCode"] == "7010") {
        resObj["reason"] = " UnderLying Is In Restricted Mode "
      } else if (resObj["rejectCode"] == "7011") {
        resObj["reason"] = " Stock not allowed for IT "
      } else if (resObj["rejectCode"] == "7020") {
        resObj["reason"] = " Positions Record not found "
      } else if (resObj["rejectCode"] == "7021") {
        resObj["reason"] = " INV GEMARGIN Record Not Found "
      } else if (resObj["rejectCode"] == "7022") {
        resObj["reason"] = " ESL Record Not Found "
      } else if (resObj["rejectCode"] == "7023") {
        resObj["reason"] = " ROD Record not found "
      } else if (resObj["rejectCode"] == "7024") {
        resObj["reason"] = " Inv HedgeMargin Record not found "
      } else if (resObj["rejectCode"] == "7025") {
        resObj["reason"] = " Invalid Product Code "
      } else if (resObj["rejectCode"] == "7026") {
        resObj["reason"] = " Lot size is zero "
      } else if (resObj["rejectCode"] == "7801") {
        resObj["reason"] = " Positions has Changed,Cannot convert to Delivery/CF "
      } else if (resObj["rejectCode"] == "7802") {
        resObj["reason"] = " Quantity Not Available for CTOD/CTOF "
      } else if (resObj["rejectCode"] == "8000") {
        resObj["reason"] = " Sql Exception "
      } else if (resObj["rejectCode"] == "7032") {
        resObj["reason"] = " Investor is Restricted to Place Order in this Stock "
      } else if (resObj["rejectCode"] == "7048") {
        resObj["reason"] = " Stock Not Available "
      } else if (resObj["rejectCode"] == "1403") {
        resObj["reason"] = " No Trading Limits Available for the Investor "
      }else {
        // resObj["reason"] = this.ErrorCode[resObj["rejectCode"]];
        // resObj["reason"] = this.ErrorCode["7048"];
        // console.log("this.ErrorCode['7048']", this.ErrorCode.7048);
      }
      /*if (resObj["reason"].length <= 0) {
        resObj["reason"] = " "
      }*/

      /*if (resObj["exchangeRemarksLength"].trim().length <= 0 || resObj["exchangeRemarksLength"].trim() <= "0") { // changed condition by Mirsha
        if (this.services.getEnvironment().shortNotification) {
          fullMessage = resObj["lastTransactTime"] + "  Exchange: Order Rejected [ Rejected Reason: " + resObj["reason"] + " ]";
        } else {
          fullMessage = resObj["lastTransactDate"] + " " + resObj["lastTransactTime"] + " IPMS : Order Rejected [ Rejected Reason :" + resObj["reason"] + "] ShortByQty- " + resObj["shortQty"] + " ShortByValue- " + (resObj["shortLimit"] / 10000) + " ExchangeOrderNo:  " + resObj["secOrderID"] + " & IntellectOrderNo: " + resObj["orderID"] + ".";
        }
      } else {*/
        if (this.services.getEnvironment().shortNotification) {
          fullMessage = resObj["lastTransactTime"] + "  Exchange: Order Rejected [ Rejected Reason: " + resObj["reason"] + " ]";
        } else {
          fullMessage = resObj["lastTransactDate"] + " " + resObj["lastTransactTime"] + " Exch : Order Rejected [ Rejected Reason :" + resObj["reason"] + "] ExchangeOrderNo:  " + resObj["secOrderID"] + " & IntellectOrderNo: " + resObj["orderID"] + ".";
        }
     // }
    } else if (appHeader == "EQORMONO") {

      resObj["product"] = this.getProductType(resObj["product"]);
      resObj["orderType"] = this.getOrderType(resObj["orderType"]);
      resObj["cashMargin"] = this.getCashMarginType(resObj["cashMargin"]);

      if (this.services.getEnvironment().shortNotification) {
        fullMessage = resObj["lastTransactTime"] + "  Exchange: Order Modification Confirmed " + this.symbolName(resObj["symbol"], resObj["exDestination"], resObj["product"]) + " " + this.orderVerbType(resObj["side"]) + " " + resObj["leavesQty"] + " @ " + resObj["price"] + " " + this.fillTypeName(resObj["exDestination"], resObj["product"], resObj["timeInForce"]) + " for Client " + resObj["clientID"];
      } else {
      fullMessage = resObj["lastTransactDate"] + " " + resObj["lastTransactTime"] + " Exchange Time: [" + resObj["exchangeLMTime"] + "] " + resObj["product"] + "  " + resObj["orderType"] + " Order Modification Confirmed - " + resObj["dispExch"] + " ExchangeOrderNo: " + resObj["secOrderID"] + " &  IntellectOrderNo: " + resObj["orderID"] + " " + resObj["cashMargin"] + " " + this.symbolName(resObj["symbol"], resObj["exDestination"], resObj["product"]) + " " + this.orderVerbType(resObj["side"]) + " " + resObj["leavesQty"] + " @ " + resObj["price"] + " " + this.fillTypeName(resObj["exDestination"], resObj["product"], resObj["timeInForce"]) + " for Client " + resObj["clientID"] + ".";
}

    } else if (appHeader == "EQORRJNO") {
      resObj["reason"] = resObj["exchangeRemarks"];
      if (resObj["rejectCode"] == "5204") {
        resObj["reason"] = " System cannot accept order entry"
      } else if (resObj["rejectCode"] == "5205") {
        resObj["reason"] = " System cannot accept order modification"
      } else if (resObj["rejectCode"] == "5206") {
        resObj["reason"] = " System cannot accept order cancellation"
      } else if (resObj["rejectCode"] == "7001") {
        resObj["reason"] = " Insufficient funds to place order"
      } else if (resObj["rejectCode"] == "7002") {
        resObj["reason"] = " Stock is in trade for trade segment,IT not allowed "
      } else if (resObj["rejectCode"] == "7003") {
        resObj["reason"] = " Investor cannot trade on IT "
      } else if (resObj["rejectCode"] == "7004") {
        resObj["reason"] = " Stock not allowed for SS"
      } else if (resObj["rejectCode"] == "7005") {
        resObj["reason"] = " Investor not allowed for SS"
      } else if (resObj["rejectCode"] == "7006") {
        resObj["reason"] = " Not Allowed For the Participant "
      } else if (resObj["rejectCode"] == "7007") {
        resObj["reason"] = " Stock Group not allowed for SS "
      } else if (resObj["rejectCode"] == "7008") {
        resObj["reason"] = " Stock not available "
      } else if (resObj["rejectCode"] == "7009") {
        resObj["reason"] = " Requested Qty for Conv is zero "
      } else if (resObj["rejectCode"] == "7010") {
        resObj["reason"] = " UnderLying Is In Restricted Mode "
      } else if (resObj["rejectCode"] == "7011") {
        resObj["reason"] = " Stock not allowed for IT "
      } else if (resObj["rejectCode"] == "7020") {
        resObj["reason"] = " Positions Record not found "
      } else if (resObj["rejectCode"] == "7021") {
        resObj["reason"] = " INV GEMARGIN Record Not Found "
      } else if (resObj["rejectCode"] == "7022") {
        resObj["reason"] = " ESL Record Not Found "
      } else if (resObj["rejectCode"] == "7023") {
        resObj["reason"] = " ROD Record not found "
      } else if (resObj["rejectCode"] == "7024") {
        resObj["reason"] = " Inv HedgeMargin Record not found "
      } else if (resObj["rejectCode"] == "7025") {
        resObj["reason"] = " Invalid Product Code "
      } else if (resObj["rejectCode"] == "7026") {
        resObj["reason"] = " Lot size is zero "
      } else if (resObj["rejectCode"] == "7801") {
        resObj["reason"] = " Positions has Changed,Cannot convert to Delivery/CF "
      } else if (resObj["rejectCode"] == "7802") {
        resObj["reason"] = " Quantity Not Available for CTOD/CTOF "
      } else if (resObj["rejectCode"] == "8000") {
        resObj["reason"] = " Sql Exception "
      } else if (resObj["rejectCode"] == "7032") {
        resObj["reason"] = " Investor is Restricted to Place Order in this Stock "
      } else if (resObj["rejectCode"] == "7048") {
        resObj["reason"] = " Stock Not Available "
      } else {
      }
      if (resObj["reason"].length <= 0) {
        resObj["reason"] = " "
      }

      if (resObj["exchangeRemarksLength"].trim().length <= 0 || resObj["exchangeRemarksLength"].trim() <= "0") { // changed condition by Mirsha
        if (resObj["cxlRejResponseTo"] == '1') {
          if (this.services.getEnvironment().shortNotification) {
            fullMessage = resObj["lastTransactTime"] + "  Exchange: Order Cancel Rejected [ Rejected Reason: " + resObj["reason"] + " ]"
          } else {
            fullMessage = resObj["lastTransactDate"] + " " + (resObj["lastTransactTime"]) + " IPMS : Order Cancellation Rejected [ Rejected Reason : " + resObj["reason"] + " ] ShortByQty- " + resObj["shortQty"] + " ShortByValue- " + (resObj["shortLimit"] / 10000) + " ExchangeOrderNo: " + resObj["secOrderID"] + " & IntellectOrderNo: " + resObj["orderID"] + ".";
          }
        } else if (resObj["cxlRejResponseTo"] == '2') {
          if (this.services.getEnvironment().shortNotification) {
            fullMessage = resObj["lastTransactTime"] + "  Exchange: Order Modification Rejected [ Rejected Reason: " + resObj["reason"] + " ]  ExchOrderNo- " + resObj["secOrderID"] + " & IntellectOrderNo- " + resObj["orderID"];
          } else {
            fullMessage = resObj["lastTransactDate"] + " " + (resObj["lastTransactTime"]) + " IPMS : Order Modification Rejected [ Rejected Reason : " + resObj["reason"] + "] ShortByQty- " + resObj["shortQty"] + " ShortByValue- " + (resObj["shortLimit"] / 10000) + " ExchangeOrderNo: " + resObj["secOrderID"] + " & IntellectOrderNo: " + resObj["orderID"] + ".";
          }
        }
      } else {
        if (resObj["cxlRejResponseTo"] == '1') {
          if (this.services.getEnvironment().shortNotification) {
            fullMessage = resObj["lastTransactTime"] + "  Exchange: Order Cancel Rejected [ Rejected Reason: " + resObj["reason"] + " ]"
          } else {
            fullMessage = resObj["exchangeLMDate"] + " " + (resObj["exchangeLMTime"]) + " Exch : Order Cancellation Rejected [ Rejected Reason : " + resObj["reason"] + " ] ExchangeOrderNo: " + resObj["secOrderID"] + " & IntellectOrderNo: " + resObj["orderID"] + ".";
          }
        } else if (resObj["cxlRejResponseTo"] == '2') {
          if (this.services.getEnvironment().shortNotification) {
            fullMessage = resObj["lastTransactTime"] + "  Exchange: Order Modification Rejected [ Rejected Reason: " + resObj["reason"] + " ]  ExchOrderNo- " + resObj["secOrderID"] + " & IntellectOrderNo- " + resObj["orderID"];
          } else {
            fullMessage = resObj["exchangeLMDate"] + " " + (resObj["exchangeLMTime"]) + " Exch : Order Modification Rejected [ Rejected Reason : " + resObj["reason"] + "] ExchangeOrderNo: " + resObj["secOrderID"] + " & IntellectOrderNo: " + resObj["orderID"] + ".";
          }
        }
      }
    } else if (appHeader == "EQORCANO") {

      resObj["product"] = this.getProductType(resObj["product"]);
      resObj["orderType"] = this.getOrderType(resObj["orderType"]);
      resObj["cashMargin"] = this.getCashMarginType(resObj["cashMargin"]);
      
      if (this.services.getEnvironment().shortNotification) {
        fullMessage = resObj["lastTransactTime"] + "  Exchange: Order Cancellation Confirmed " + this.symbolName(resObj["symbol"], resObj["exDestination"], resObj["product"]) + " " + this.orderVerbType(resObj["side"]) + " " + resObj["cancelledQty"] + " @ " + resObj["price"] + " for Client " + resObj["clientID"];
      } else {
        fullMessage = resObj["lastTransactDate"] + " " + resObj["lastTransactTime"] + " Exchange Time: [" + (resObj["exchangeLMTime"]) + "] " + resObj["product"] + "  " + resObj["orderType"] + " Order Cancellation Confirmed - " + resObj["dispExch"] + " ExchangeOrderNo: " + resObj["secOrderID"] + " & IntellectOrderNo: " + resObj["orderID"] + " " + resObj["cashMargin"] + " " + this.symbolName(resObj["symbol"], resObj["exDestination"], resObj["product"]) + " " + this.orderVerbType(resObj["side"]) + " " + resObj["cancelledQty"] + " @ " + resObj["price"] + " " + this.fillTypeName(resObj["exDestination"], resObj["product"], resObj["timeInForce"]) + " for Client " + resObj["clientID"] + ".";
      }
    } else if (appHeader == "OROWCHNO") {
      resObj["product"] = this.getProductType(resObj["product"]);
      resObj["orderType"] = this.getOrderType(resObj["orderType"]);
      resObj["cashMargin"] = this.getCashMarginType(resObj["cashMargin"]);
      
      if (this.services.getEnvironment().shortNotification) {
        fullMessage = resObj["lastTransactTime"] + "  Intellect: Order Ownership Changed " + this.symbolName(resObj["symbol"], resObj["exDestination"], resObj["product"]) + " " + resObj["orderQty"] + " @ " + resObj["price"] + " for Client " + resObj["clientID"];
      } else {
        fullMessage = resObj["lastTransactDate"] + " " + resObj["lastTransactTime"] + " Investor: " + resObj["clientID"] + " Order Ownership Changed Local Order ref." + resObj["orderID"] + " Details:  " + this.symbolName(resObj["symbol"], resObj["exDestination"], resObj["product"]) + " " + resObj["orderQty"] + " @ " + resObj["price"] + ".";
      }
    }

    else if (appHeader == "SPORCAAO") { //spread order cancel notification
      resObj["product"] = this.getProductType(resObj["product"]);
      resObj["orderType"] = this.getOrderType(resObj["orderType"]);
      resObj["cashMargin"] = this.getCashMarginType(resObj["cashMargin"]);
      
      if (this.services.getEnvironment().shortNotification) {
        fullMessage = resObj["lastTransactTime"] + "  Exchange: Order Cancellation Confirmed " + this.symbolName(resObj["symbol"], resObj["exDestination"], resObj["product"]) + " " + this.orderVerbType(resObj["side"]) + " " + resObj["cancelledQty"] + " @ " + resObj["price"] + " for Client " + resObj["clientID"];
      } else {
        fullMessage = resObj["lastTransactDate"] + " " + resObj["lastTransactTime"] + " Exchange Time: [" + (resObj["exchangeLMTime"]) + "] " + resObj["product"] + "  " + resObj["orderType"] + " Order Cancellation Confirmed - " + resObj["dispExch"] + " ExchangeOrderNo: " + resObj["secOrderID"] + " & IntellectOrderNo: " + resObj["orderID"] + " " + resObj["cashMargin"] + " " + this.symbolName(resObj["symbol"], resObj["exDestination"], resObj["product"]) + " " + this.orderVerbType(resObj["side"]) + " " + resObj["cancelledQty"] + " @ " + resObj["price"] + " " + this.fillTypeName(resObj["exDestination"], resObj["product"], resObj["timeInForce"]) + " for Client " + resObj["clientID"] + ".";
      }
    }
    else if (appHeader == "SPORADNO") { //spread order add notification
      console.log("in spread confirmation notification");
      resObj["product"] = this.getProductType(resObj["product"]);
      resObj["orderType"] = this.getOrderType(resObj["orderType"]);
      resObj["cashMargin"] = this.getCashMarginType(resObj["cashMargin"]);

      if (this.services.getEnvironment().shortNotification) {
        fullMessage = resObj["lastTransactTime"] + "  Exchange: Order Confirmed " + this.symbolName(resObj["symbol"], resObj["exDestination"], resObj["product"]) + " " + this.orderVerbType(resObj["side"]) + " " + resObj["orderQty"] + " @ " + resObj["price"] + " for Client " + resObj["clientID"];
      console.log("fullMessage..,",fullMessage);
      } else {
        fullMessage = resObj["lastTransactDate"] + " " + resObj["lastTransactTime"] + " Exchange Time: [" + resObj["exchangeLMTime"] + "] " + resObj["product"] + " " + resObj["orderType"] + " Order Confirmed - " + resObj["dispExch"] + " ExchangeOrderNo : " + resObj["secOrderID"] + " & IntellectOrderNo : " + resObj["orderID"] + " " + resObj["cashMargin"] + " " + this.symbolName(resObj["symbol"], resObj["exDestination"], resObj["product"]) + " " + this.orderVerbType(resObj["side"]) + " " + resObj["orderQty"] + " @ " + resObj["price"] + " " + this.fillTypeName(resObj["exDestination"], resObj["product"], resObj["timeInForce"]) + " for Client " + resObj["clientID"] + ".";
      console.log("fullMessage..",fullMessage);
      }

    }

    else if (appHeader == "SPORADRO") { //spread order add reject notification
      resObj["reason"] = resObj[""];
      console.log("resObj rejectCode",resObj["rejectCode"]);
      if (resObj["rejectCode"] == "5204") {
        resObj["reason"] = " System cannot accept order entry";
      } else if (resObj["rejectCode"] == "5205") {
        resObj["reason"] = " System cannot accept order modification"
      } else if (resObj["rejectCode"] == "5206") {
        resObj["reason"] = " System cannot accept order cancellation"
      } else if (resObj["rejectCode"] == "7001") {
        resObj["reason"] = " Insufficient funds to place order"
      } else if (resObj["rejectCode"] == "7002") {
        resObj["reason"] = " Stock is in trade for trade segment,IT not allowed "
      } else if (resObj["rejectCode"] == "7003") {
        resObj["reason"] = " Investor cannot trade on IT "
      } else if (resObj["rejectCode"] == "7004") {
        resObj["reason"] = " Stock not allowed for SS"
      } else if (resObj["rejectCode"] == "7005") {
        resObj["reason"] = " Investor not allowed for SS"
      } else if (resObj["rejectCode"] == "7006") {
        resObj["reason"] = " Not Allowed For the Participant "
      } else if (resObj["rejectCode"] == "7007") {
        resObj["reason"] = " Stock Group not allowed for SS "
      } else if (resObj["rejectCode"] == "7008") {
        resObj["reason"] = " Stock not available "
      } else if (resObj["rejectCode"] == "7009") {
        resObj["reason"] = " Requested Qty for Conv is zero "
      } else if (resObj["rejectCode"] == "7010") {
        resObj["reason"] = " UnderLying Is In Restricted Mode "
      } else if (resObj["rejectCode"] == "7011") {
        resObj["reason"] = " Stock not allowed for IT "
      } else if (resObj["rejectCode"] == "7020") {
        resObj["reason"] = " Positions Record not found "
      } else if (resObj["rejectCode"] == "7021") {
        resObj["reason"] = " INV GEMARGIN Record Not Found "
      } else if (resObj["rejectCode"] == "7022") {
        resObj["reason"] = " ESL Record Not Found "
      } else if (resObj["rejectCode"] == "7023") {
        resObj["reason"] = " ROD Record not found "
      } else if (resObj["rejectCode"] == "7024") {
        resObj["reason"] = " Inv HedgeMargin Record not found "
      } else if (resObj["rejectCode"] == "7025") {
        resObj["reason"] = " Invalid Product Code "
      } else if (resObj["rejectCode"] == "7026") {
        resObj["reason"] = " Lot size is zero "
      } else if (resObj["rejectCode"] == "7801") {
        resObj["reason"] = " Positions has Changed,Cannot convert to Delivery/CF "
      } else if (resObj["rejectCode"] == "7802") {
        resObj["reason"] = " Quantity Not Available for CTOD/CTOF "
      } else if (resObj["rejectCode"] == "8000") {
        resObj["reason"] = " Sql Exception "
      } else if (resObj["rejectCode"] == "7032") {
        resObj["reason"] = " Investor is Restricted to Place Order in this Stock "
      } else if (resObj["rejectCode"] == "7048") {
        resObj["reason"] = " Stock Not Available "
      } else if (resObj["rejectCode"] == "1403") {
        resObj["reason"] = " No Trading Limits Available for the Investor "
      }else if (resObj["rejectCode"] == "14014") {
        resObj["reason"] = " Price exceeds current price band "
      }else if (resObj["rejectCode"] == "14086") {
        resObj["reason"] = " Last Trading Date of instrument elapsed "
      } else if (resObj["rejectCode"] == "14126") {
        resObj["reason"] = " Session is closed "
      }
      else {
        // resObj["reason"] = this.ErrorCode[resObj["rejectCode"]];
        // resObj["reason"] = this.ErrorCode["7048"];
      }
      /*if (resObj["reason"].length <= 0) {
        resObj["reason"] = " "
      }*/
      /*if (resObj["exchangeRemarksLength"].trim().length <= 0 || resObj["exchangeRemarksLength"].trim() <= "0") { 
        if (this.services.getEnvironment().shortNotification) {
          fullMessage = resObj["lastTransactTime"] + "  Exchange: Order Rejected [ Rejected Reason: " + resObj["reason"] + " ]";
        } else {
          fullMessage = resObj["lastTransactDate"] + " " + resObj["lastTransactTime"] + " IPMS : Order Rejected [ Rejected Reason :" + resObj["reason"] + "] ShortByQty- " + resObj["shortQty"] + " ShortByValue- " + (resObj["shortLimit"] / 10000) + " ExchangeOrderNo:  " + resObj["secOrderID"] + " & IntellectOrderNo: " + resObj["orderID"] + ".";
        }
      } else {*/
      if (this.services.getEnvironment().shortNotification) {
          fullMessage = resObj["lastTransactTime"] + "  Exchange: Order Rejected [ Rejected Reason: " + resObj["reason"] + " ]";
        } else {
          fullMessage = resObj["lastTransactDate"] + " " + resObj["lastTransactTime"] + " Exch : Order Rejected [ Rejected Reason :" + resObj["reason"] + "] ExchangeOrderNo:  " + resObj["secOrderID"] + " & IntellectOrderNo: " + resObj["orderID"] + ".";
        }

        
     // }
    } 

    return fullMessage;
  }

  getProductType(type) {
    var productType = "";
    switch (type) {
      case '2':
        productType = "COMDERV";
       break;

      case '5':
        productType = "EQUITY";
        break;

      case '9':
        productType = "DEBT";
        break;
       
       case '13':
        productType = "FUTOPT";
       break;

      default: productType = " ";
    }
    return productType;
  }

  getOrderType(type) {
    var orderType = "";
    switch (type) {
      case '1':
        orderType = "MARKET";
        break;

      case '2':
        orderType = "LIMIT";
        break;

      case '3':
        orderType = "STOP MARKET";
        break;

      case '4':
        orderType = "STOP LIMIT";
        break;

      case '5':
        orderType = "MARKET TO LIMIT";
        break;

      case '6':
        orderType = "SPL MARKET";
        break;

      case '7':
        orderType = "ICEBERG";
        break;

      default: orderType = " ";
    }
    return orderType;
  }

  getCashMarginType(type) {
    var marginType = "";
    switch (type) {
      case '1':
        marginType = "DELIVERY";
        break;

      case '2':
        marginType = "INTRADAY";
        break;

      case '3':
        marginType = "CARRYFORWARD";
        break;

      default: marginType = " ";
    }
    return marginType;
  }

  tradeOrderVerb(side) {

    var orderVerb = "";
    switch (side) {
      case '1':
        orderVerb = "BOUGHT";
        break;
      case '2':
        orderVerb = "SOLD";
        break;
      case '5':
        orderVerb = "SOLD";
        break;
      default: orderVerb = " ";
    }
    return orderVerb;
  }
  
  symbolName(symbolId, exch, productID) {
    if (typeof symbolId == "object") {
      return symbolId.label;
    } else {
      return this.services.dataStore.getSymbolByExchSymbol(symbolId, exch, productID);
    }
  }

  orderVerbType(side) {
    var orderVerb = "";
    switch (side) {
      case '1':
        orderVerb = "BUY";
        break;

      case '2':
        orderVerb = "SELL";
        break;

      case 'D':
        orderVerb = "SUBSCRIBE";
        break;

      case 'E':
        orderVerb = "REDEEM";
        break;

      case '5':
        orderVerb = "SHORT SELL";
        break;

      default: orderVerb = " ";
    }
    return orderVerb;
  }

  fillTypeName(Exchange, Product, fill) {
    var fillTypeMsg = "";
    fillTypeMsg = this.filltypeNameMap.get(Exchange.toLowerCase() + "_" + Product.toLowerCase() + "_" + fill.toLowerCase());

    return fillTypeMsg;
  }

  notificationMessage(message) {
    // console.log("Notification Msg: ", message);

    this.notificationList.splice(0, 0, message);

    this.notifyCount++;

    if (this.notificationList.length == 1) {
      this.openModal();
    }
  }

  clearNotifications() {
  this.notificationList = [];
  this.notifyCount = 0;
  console.log("Notifications cleared on login",this.notificationList,this.notifyCount);
}

  openModal() {
    this.notifyCount = 0;
    const modalRef = this.services.openModal(gotxModalComponent, 'lg', null, "Notification");
  }
}
